import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  CircularProgress,
  Typography,
  useTheme,
  FormControlLabel,
  Card,
  CardContent,
  Skeleton,
} from "@mui/material";
import CardPost from "./CardPost";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import { Row, Col, Container } from "react-bootstrap";
import dayjs from "dayjs";
import AnimatedLoading from "components/Loading/aminateLoading";
import ArchiveSwitch from "components/archiveSwich/archiveSwich";
import { ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import CustomPagination from "views/client/pagination";
import NoArchivedPosts from "./NoArchivedPosts";
import PostDetailsDialog from "./Dialogs/PostDetails";
import WorkingDetailsDialog from "./Dialogs/WorkingDetailsDialog";
import { useSnackbar } from "hooks/useSbackbar";
import { useTranslation } from "react-i18next";
import ArchivedPosts from "./ArchivedOffers";
import JobCard from "views/Landing/JobCard";
import JobCardRec from "./JobCardRec";
import JobCardRecSkeleton from "./components/skeletonPost";
// import ArchivedOffers from "./ArchivedOffers";


const PublishedOffers = ({
  filter,
  filteredCards,
  loadPublishedPosts,
  companyLogo,
  company,
  updatePost,
  setUpdatedData,
  totalPosts,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  onArchivePost,
  deletePostById: parentDeletePostById,
  handlePostClick,
  loading
}) => {
  const [postImage, setPostImage] = useState("");
  const [postTitle, setPostTitle] = useState("");
  const [ref] = useState(false);
  const [postDescription, setPostDescription] = useState("");
  const [postRequirement, setPostRequirement] = useState([]);
  const [postDeadline, setPostDeadline] = React.useState(null);
  // const [posts, setPosts] = useState([]);
  // const [filter, setFilter] = useState("");
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  const theme = useTheme();
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiUrlFront = process.env.REACT_APP_API_FRONT_URL;
  const userId = getUserIdFromAccessToken();
  const [errors, setErrors] = useState({});
  const [offerType, setOfferType] = useState("");
  const [location, setLocation] = useState(null);
  const [numPeople, setNumPeople] = useState(null);
  const [salary, setSalary] = useState(null);
  const [isCheckedScr, setIsCheckedScr] = useState(false);
  const [workingMode, setWorkingMode] = useState("");
  const [showArchived, setShowArchived] = useState(false);
  const [currency, setCurrency] = useState("MAD");
  const client_id = "86dpwd87p8nanb";
  const [postId, setPostId] = useState();
  const navigate = useNavigate();
  const [fieldOfStudy, setFieldOfStudy] = useState("");
  const [otherFieldOfStudy, setOtherFieldOfStudy] = useState("");
  const [experience, setExperience] = useState("");
  const { t } = useTranslation();
  const [diploma, setDiploma] = useState("");
  const [otherDiploma, setOtherDiploma] = useState("");
  const [dateError, setDateError] = useState("");
  const [isArchived, setIsArchived] = useState(false);
  
  // Debug logging for filteredCards
  useEffect(() => {
    console.log('🔍 PublishedOffers - filteredCards received:', filteredCards?.length || 0, 'posts');
    console.log('📋 filteredCards data 2:', filteredCards);
  }, [filteredCards]);

  const handleLocalPostClick = (post) => {
    const scrollPosition = window.scrollY;
    localStorage.setItem('publishedPostsScroll', scrollPosition.toString());
    localStorage.setItem('publishedPostsPage', (page + 1).toString());
    
    if (handlePostClick) {
      handlePostClick(post);
    } else {
      // Fallback navigation if parent doesn't provide handler
      const encodedId = btoa(post.id);
      if(post.reference){
        navigate(`/talent/post/scraped/${encodedId}`);
      }else{
        navigate(`/talent/post/${encodedId}`);
      }
      localStorage.setItem("currentPostId", encodedId);
    }
  };

  // Restore scroll position when component mounts
  useEffect(() => {
    const savedScroll = localStorage.getItem('publishedPostsScroll');
    if (savedScroll) {
      window.scrollTo({
        top: parseInt(savedScroll),
        behavior: 'instant'
      });
    }
  }, [filteredCards]); // Run after filteredCards are updated

  const handleDateChange = (newValue) => {
    const dateOnly = newValue ? dayjs(newValue).format("YYYY-MM-DD") : null;

    if (newValue && dayjs(newValue).isBefore(dayjs().add(1, "day"), "day")) {
      setDateError(t("errors.dateMustBeTomorrowOrLater"));
      setPostDeadline(null);
    } else {
      setDateError("");
      setPostDeadline(dateOnly);
    }
  };

  const convertOfferType = (type) => {
    return type === "internship" ? "i" : "j";
  };

  const validateFirstDialog = () => {
    let tempErrors = {};
    tempErrors.postTitle = postTitle ? "" : t("postPage.errors.postTitle");
    tempErrors.postDescription = postDescription
      ? ""
      : t("postPage.errors.postDescription");
    tempErrors.postRequirement =
      postRequirement.length > 0 ? "" : t("postPage.errors.postRequirement");
    tempErrors.postDeadline = postDeadline
      ? ""
      : t("postPage.errors.postDeadline");
    tempErrors.offerType = offerType ? "" : t("postPage.errors.offerType");
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const validateSecondDialog = () => {
    let tempErrors = {};
    tempErrors.location = location ? "" : t("postPage.errors.location");
    tempErrors.workingMode = workingMode
      ? ""
      : t("postPage.errors.workingMode");
    tempErrors.postImage = postImage ? "" : t("postPage.errors.postImage");
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const handleNext = () => {
    if (validateFirstDialog()) {
      setOpen(false);
      setOpen2(true);
    }
  };

  const handleSave = async () => {
    if (validateSecondDialog()) {
      await save();
    }
  };
 

  useEffect(() => {
    const handleAuthMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      const { code } = event.data;
      if (code) {
        fetchCallbackData(code);
      }
    };

    window.addEventListener("message", handleAuthMessage, false);

    return () => {
      window.removeEventListener("message", handleAuthMessage, false);
    };
  }, []);

  const handleLinkedInAuth = () => {
    const redirectUri = encodeURIComponent(
      `${window.location.origin}/talent/post/PostDetails/`
    );
    const linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${client_id}&redirect_uri=${redirectUri}&scope=openid%20email%20profile%20w_member_social`;
    const newWindow = window.open(linkedInAuthUrl, "_blank");

    window.addEventListener("message", handleAuthMessage, false);

    function handleAuthMessage(event) {
      if (event.origin !== window.location.origin) return;

      const { code } = event.data;
      if (code) {
        window.removeEventListener("message", handleAuthMessage);
        newWindow.close();
      }
    }
  };

  const fetchCallbackData = async (code) => {
    try {
      const response = await axios.get(
        `${apiUrl}authentication/linkedin_callback_post/`,
        {
          params: { code: code },
        }
      );
      localStorage.setItem(
        "accessToken_LinkedIn",
        response.data.linkedIn_access_token
      );
      localStorage.setItem(
        "linkedin_person_id",
        response.data.linkedin_person_id
      );
      handleCreatePost(
        response.data.linkedIn_access_token,
        response.data.linkedin_person_id
      );
      resetForm();
    } catch (error) {
      console.error("Error fetching data from callback:", error);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    if (code) {
      fetchCallbackData(code);
    }
  }, []);

  const handleCreatePost = async (token, personnalId) => {
    const formData = JSON.parse(localStorage.getItem("postFormData"));
    if (!formData) {
      console.error("Form data not found in localStorage");
      return;
    }

    const {
      postImage,
      postTitle,
      postDescription,
      postRequirement,
      postDeadline,
      location,
      numPeople,
      workingMode,
      salary,
      currency,
      offerType,
      postId,
    } = formData;

    if (
      !postTitle ||
      !postDeadline ||
      !location ||
      !postDescription ||
      !postRequirement ||
      !postId
    ) {
      toast.error(t("postPage.errors.missingFields"));
      return;
    }

    try {
      const response = await axios.post(
        `${apiUrl}authentication/linkedin/post-create/`,
        {
          token: token,
          personnalId: personnalId,
          subject: postTitle,
          lien: `${apiUrlFront}viewjob/${postId}`,
          postDeadline: postDeadline,
          location: location,
          postImage: postImage,
          postDescription: postDescription,
          requirement: postRequirement,
          workMode: workingMode,
          salary: salary || null,
          numToHire: numPeople || null,
          currency: currency,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      toast.success(t("postPageMeta.success.postCreated"));
      resetForm();
      localStorage.removeItem("linkedin_person_id");
      localStorage.removeItem("accessToken_LinkedIn");
      localStorage.removeItem("postFormData");

      if (window.opener) {
        window.opener.postMessage(
          { action: "postCreated" },
          window.location.origin
        );
        window.close();
      }
    } catch (error) {
      console.error("Error creating post:", error);
      toast.error(t("postPage.errors.postCreationFailed"));
    }
  };

  // const filteredCards = posts.filter((post) => {
  //   const job = post.title.toLowerCase();
  //   const filterLower = filter.toLowerCase();
  //   return job.startsWith(filterLower);
  // });

  useEffect(() => {
    window.addEventListener("message", handlePostCreatedMessage);
    return () => {
      window.removeEventListener("message", handlePostCreatedMessage);
    };
  }, []);

  const handlePostCreatedMessage = (event) => {
    if (event.origin !== window.location.origin) return;
    if (event.data.action === "postCreated") {
      if (loadPublishedPosts) {
        loadPublishedPosts();
      }
      toast.success(t("postPageMeta.success.postCreated"));
    }
  };

  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      const userId = decodedToken.user_id;
      return userId;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }

  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }





  const handleArchiveSwitch = (event) => {
    setShowArchived(event.target.checked);
  };





  async function save() {
    console.log('💾 Starting save function...');
    setOpen2(false);
    const formData = {
      postImage,
      postTitle,
      postDescription,
      postRequirement,
      postDeadline,
      location,
      workingMode,
      currency,
      offerType,
    };

    try {
      console.log('📤 Sending POST request to create post...');
      const response = await axios.post(`${apiUrl}posts/create/`, {
        image: postImage,
        title: postTitle,
        description: postDescription,
        requirements: postRequirement,
        deadline: postDeadline,
        recruiter: userId,
        mode: workingMode,
        salary: salary || null,
        age_experience: numPeople || null,
        scraped: isCheckedScr,
        currency: currency,
        localisation: location,
        offerType: convertOfferType(offerType),
        education: `${diploma || otherDiploma} ${
          fieldOfStudy || otherFieldOfStudy
        }`,
        experiences: experience,
      });

      console.log('✅ Post created successfully with ID:', response.data.id);
      const newPostId = response.data.id;
      setPostId(newPostId);
      formData.postId = newPostId;

      if (isChecked) {
        localStorage.setItem("postFormData", JSON.stringify(formData));
        if (
          !localStorage.getItem("linkedin_person_id") ||
          !localStorage.getItem("accessToken_LinkedIn")
        ) {
          handleLinkedInAuth();
        } else {
          handleCreatePost(
            localStorage.getItem("accessToken_LinkedIn"),
            localStorage.getItem("linkedin_person_id")
          );
        }
      }

      resetForm();
      console.log('✅ Post creation completed, parent will handle refresh');
      toast.success(t("postPageMeta.success.postCreated"));
      console.log('✅ Save function completed successfully');
    } catch (err) {
      console.error("❌ Post Registration Failed:", err);
      if (err.response) {
        toast.error(
          `Post Registration Failed: ${
            err.response.data.message || err.response.statusText
          }`
        );
      } else if (err.request) {
        toast.error(
          "Post Registration Failed: No response received from server"
        );
      } else {
        toast.error(`Post Registration Failed: ${err.message}`);
      }
    }
  }

  const resetForm = () => {
    setPostTitle("");
    setPostDescription("");
    setPostRequirement([]);
    setOfferType("");
    setPostDeadline("");
    setPostImage("");
    setSalary("");
    setNumPeople("");
    setDiploma("");
    setOtherDiploma("");
    setFieldOfStudy("");
    setOtherFieldOfStudy("");
    setExperience("");
    setWorkingMode("");
    setLocation("");
    setCurrency("MAD");
  };

  const handleImageUpload = (postImage) => {
    setPostImage(postImage);
    setErrors((prev) => ({ ...prev, postImage: "" }));
  };

  const { showSnackbar } = useSnackbar();

  // Use parent's delete function if provided, otherwise use local one
  const handleDeletePost = parentDeletePostById || deletePostById;
  
  // Use parent's archive function if provided, otherwise use local one  
  const handleArchivePost = onArchivePost || localOnArchivePost;

  const deletePostById = async (postId) => {
    try {
      await axios.delete(`${apiUrl}posts/${postId}/delete/`);
      if (loadPublishedPosts) {
        loadPublishedPosts();
      }
      showSnackbar(t("postPage.success.postDeleted"), "success");
    } catch (error) {
      showSnackbar(t("postPage.errors.postDeletionFailed"), "error");
    }
  };

  const handleUpdatePost = async (updatedData) => {
    try {
      console.log("updatedData==:", updatedData);
      // Extract postId and remove it from the data being sent
      const { postId, ...dataToUpdate } = updatedData;
      console.log("it's been called here 3!!")
      const response = await axios.put(
        `${apiUrl}posts/${postId}/update/`,
        dataToUpdate,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
          }
        }
      );

      if (response.status === 200) {
        const updatedPost = response.data;
        
        // Let parent component handle the state update
        if (loadPublishedPosts) {
          loadPublishedPosts();
        }
        
        toast.success(t("postPage.success.postUpdated") || "Post updated successfully");
      }
    } catch (error) {
      console.error(`Error updating post:`, error.response?.data || error.message);
      toast.error(t("postPage.errors.postUpdateFailed") || "Failed to update post");
    }
  };

  const handleSelectPost = (post) => {
    setSelectedPost(post);
  };

  const handleSalaryChange = (value) => {
    setSalary(value ? parseFloat(value) : null);
  };

  const localOnArchivePost = async (postId, archivedStatus) => {
    try {
      const post = filteredCards.find((p) => p.id === postId);
      if (post && new Date(post.deadline) < new Date()) {
        toast.warning(t("postPage.warnings.deadlineChangeRequired"));
        return;
      }

      const response = await fetch(
        `${apiUrl}posts/${postId}/archive/${userId}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
          body: JSON.stringify({ archived: archivedStatus }),
        }
      );
      if (response.ok) {
        // Note: Parent component will handle the actual state update
        if (loadPublishedPosts) {
          loadPublishedPosts();
        }
        
        toast.success(
          t(
            `postPage.success.${
              archivedStatus ? "postArchived" : "postUnarchived"
            }`
          )
        );
      } else {
        toast.error(t("postPage.errors.archiveUpdateFailed"));
      }
    } catch (error) {
      console.error(`Error updating archive status: ${error.message}`);
      toast.error(t("postPage.errors.archiveUpdateFailed"));
    }
  };

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCheckboxChangeScr = (event) => {
    setIsCheckedScr(event.target.checked);
  };

  if (showArchived) {
    return (
      <ArchivedPosts
        onSwitchChange={handleArchiveSwitch}
        isArchived={showArchived}
      />
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="d-flex flex-column content">
        {/* {loading ? (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            {[...Array(6)].map((_, index) => (
              <Box 
                key={`skeleton-${index}`}
                sx={{
                  flex: '1 1 calc(33.333% - 16px)',
                  minWidth: '300px',
                  maxWidth: 'calc(33.333% - 16px)',
                  '@media (max-width: 1200px)': {
                    flex: '1 1 calc(50% - 16px)',
                    maxWidth: 'calc(50% - 16px)',
                  },
                  '@media (max-width: 600px)': {
                    flex: '1 1 100%',
                    maxWidth: '100%',
                  }
                }}
              >
                <JobCardRecSkeleton />
              </Box>
            ))}
          </Box>
        ) : ( */}
          <Container>
            <>
              <Container fluid className="px-4">
                <Row className="g-4">
                  {loading ? (
                    // Show skeletons while loading
                    [...Array(6)].map((_, index) => (
                      <Col
                        key={`skeleton-${index}`}
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={4}
                        xxl={3}
                      >
                        <JobCardRecSkeleton />
                      </Col>
                    ))
                  ) : (
                    // Show actual job cards when loaded
                    filteredCards.map((post) => (
                      <Col
                        key={post.id}
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={4}
                        xxl={3}
                      >
                        <JobCardRec
                          job={post}
                          postid={post.id}
                          imageSrc={post.image}
                          title={post.title}
                          description={post.description}
                          requirement={post.requirements}
                          deadline={post.deadline}
                          company={post.company}
                          companyLogo={companyLogo}
                          onDeletePost={handleDeletePost}
                          updatePost={handleUpdatePost}
                          handleImageUpload={handleImageUpload}
                          archived={post.archived}
                          onArchivePost={handleArchivePost}
                          onSelectPost={() => handleLocalPostClick(post)}
                          isArchived={isArchived}
                          onUpdateSuccess={loadPublishedPosts}
                        />
                      </Col>
                    ))
                  )}
                  {!loading && filteredCards.length === 0 && (
                    <Box sx={{ textAlign: "center", py: 4 }}>
                      <Typography variant="h6">
                        <NoArchivedPosts text={false} />
                      </Typography>
                    </Box>
                  )}
                </Row>
              </Container>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  padding: "26px 0",
                }}
              >
                {filteredCards.length > 0 && totalPosts > 0 ? (
                  <CustomPagination
                    page={page}
                    handleChangePage={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    count={totalPosts}
                  />
                ) : (
                  ""
                )}
              </Box>
            </>
            <PostDetailsDialog
              setOpen={setOpen}
              postTitle={postTitle}
              setPostTitle={setPostTitle}
              postDescription={postDescription}
              setPostDescription={setPostDescription}
              offerType={offerType}
              setOfferType={setOfferType}
              postRequirement={postRequirement}
              setPostRequirement={setPostRequirement}
              postDeadline={postDeadline}
              handleDateChange={handleDateChange}
              handleNext={handleNext}
              open={open}
              errors={errors}
              showRef={ref}
            />
            <WorkingDetailsDialog
              setOpen2={setOpen2}
              setOpen={setOpen}
              open2={open2}
              errors={errors}
              handleImageUpload={handleImageUpload}
              setWorkingMode={setWorkingMode}
              workingMode={workingMode}
              location={location}
              setLocation={setLocation}
              setErrors={setErrors}
              numPeople={numPeople}
              setNumPeople={setNumPeople}
              salary={salary}
              handleSalaryChange={handleSalaryChange}
              currency={currency}
              setCurrency={setCurrency}
              isChecked={isChecked}
              handleCheckboxChange={handleCheckboxChange}
              isCheckedScr={isCheckedScr}
              handleCheckboxChangeScr={handleCheckboxChangeScr}
              handleSave={handleSave}
              fieldOfStudy={fieldOfStudy}
              setFieldOfStudy={setFieldOfStudy}
              otherFieldOfStudy={otherFieldOfStudy}
              setOtherFieldOfStudy={setOtherFieldOfStudy}
              experience={experience}
              setExperience={setExperience}
              diploma={diploma}
              setDiploma={setDiploma}
              otherDiploma={otherDiploma}
              setOtherDiploma={setOtherDiploma}
            />
          </Container>
        {/* )} */}
      </div>
    </ThemeProvider>
  );
};

export default PublishedOffers;
